import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'

export const deleteKpiBranchAssignment = async (id: string): Promise<void> => {
  try {
    await axios.delete(`${BASE_URL}/kpi/branch-assignments/${id}/`)
  } catch (error) {
    throw error
  }
}
